// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-registration .page-title {
  margin-bottom: 0;
}

.page-registration .page-title + .page-description {
  margin-top: 16px;
}

.page-registration .page-title + .input-with-indicator-container {
  margin-top: 32px;
}

.page-registration .page-description {
  text-align: center;

  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 24px;
}

.page-registration .registration-description-container {
  display: flex;
  margin-top: 16px;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #bdbdbd;
}

.page-registration .registration-description-container .icon-container {
  margin: 3px 14px auto 0;
}

.page-registration .registration-description-container .text {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: var(--dark-gray);
}

.page-registration .button-container {
  margin: 40px auto 80px;
  max-width: 264px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/registration.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".page-registration .page-title {\n  margin-bottom: 0;\n}\n\n.page-registration .page-title + .page-description {\n  margin-top: 16px;\n}\n\n.page-registration .page-title + .input-with-indicator-container {\n  margin-top: 32px;\n}\n\n.page-registration .page-description {\n  text-align: center;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 24px;\n}\n\n.page-registration .registration-description-container {\n  display: flex;\n  margin-top: 16px;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.02em;\n  color: #bdbdbd;\n}\n\n.page-registration .registration-description-container .icon-container {\n  margin: 3px 14px auto 0;\n}\n\n.page-registration .registration-description-container .text {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--dark-gray);\n}\n\n.page-registration .button-container {\n  margin: 40px auto 80px;\n  max-width: 264px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
